module.exports = __webpack_public_path__ + "img/lap.099d9d68.png";